<template>
  <div class="db-setting-popup">
    <div class="goback-small c-pointer l-align"><i class="fal fa-arrow-left" @click="onBackBtnClick"></i> 데이터베이스 {{ settingType }}</div>
    <el-form :model="formData" :rules="rules" label-width="120px" ref="form" label-position="top">
      <el-row>
        <el-col :span="12">
          <el-form-item label="DB 명" prop="dbId">
            <el-input v-model="formData.dbId" placeholder="DB명을 입력해 주십시오"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11" class="dbtype-item">
          <el-form-item label="DB Type" prop="dbType">
            <el-select v-model="formData.dbType" placeholder="DB타입을 선택해 주십시오" @change="onDbtypeComboChange">
              <el-option v-for="item in dbTypeInfo" :key="item.dbType" :label="item.dbType" :value="item.dbType"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="DB Driver" prop="dbDriver">
          <el-input v-model="formData.dbDriver"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="DB URL" prop="dbUrl">
          <el-input v-model="formData.dbUrl"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="User" prop="dbUser">
          <el-input v-model="formData.dbUser"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="Password" prop="dbPasswd">
          <el-input type="password" v-model="formData.dbPasswd"></el-input>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { find, assign, cloneDeep } from 'lodash';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';
import MsgUtil from '@/utils/message';
import SqlAPI from '@/api/dashboard/sql';

export default {
  name: 'WDbInfoSettingForm',
  props: {
    settingType: {
      type: String,
      default: '추가',
    },
  },
  data() {
    return {
      formData: {
        dbId: null,
        dbType: null,
        dbDriver: null,
        dbUrl: null,
        dbUser: null,
        dbPasswd: null,
      },
      dbTypeInfo: null,
      rules: {
        dbId: [
          {
            required: true,
            message: 'DB 명을 입력해주십시오.',
            trigger: 'blur',
          },
        ],
        dbDriver: [
          {
            required: true,
            message: 'DB Driver를 입력해주십시오.',
            trigger: 'blur',
          },
        ],
        dbUrl: [
          {
            required: true,
            message: 'DB Url을 입력해주십시오.',
            trigger: 'blur',
          },
        ],
        dbUser: [
          {
            required: true,
            message: 'DB 유저정보를 입력해주십시오.',
            trigger: 'blur',
          },
        ],
        dbPasswd: [
          {
            required: true,
            message: 'DB Password를 입력해주십시오.',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  created() {
    SqlAPI.getDbtypeInfo().then((response) => {
      this.dbTypeInfo = response.data.data;
    });
  },
  methods: {
    addInfo() {
      const action = MsgUtil.action.ADD;
      const target = 'DB 정보';
      const encryptTargetData = createEncryptTargetData(this.formData, ['dbPasswd']);
      getRsaEncrypt(encryptTargetData)
        .then((encryptData) => {
          SqlAPI.addDbInfo(assign(cloneDeep(this.formData), encryptData))
            .then((response) => {
              const result = response.data;
              if (result.success) {
                this.$message(MsgUtil.getResultMsgData(action, target, true));
                this.$emit('loadData');
                this.onBackBtnClick();
              } else {
                this.$message(MsgUtil.getResultMsgData(action, target, false));
              }
            })
            .catch((e) => {
              this.$message(MsgUtil.getResultMsgData(action, target, false));
              throw new Error(e);
            });
        })
        .catch((e) => {
          this.$message(MsgUtil.getResultMsgData(action, target, true));
          throw new Error(e);
        });
    },
    updateInfo() {
      const action = MsgUtil.action.MODIFY;
      const target = 'DB 정보';
      const encryptTargetData = createEncryptTargetData(this.formData, ['dbPasswd']);
      getRsaEncrypt(encryptTargetData)
        .then((encryptData) => {
          SqlAPI.updateDbInfo(assign(cloneDeep(this.formData), encryptData)).then((response) => {
            const result = response.data;
            if (result.success) {
              this.$message(MsgUtil.getResultMsgData(action, target, true));
              this.$emit('loadData');
              this.onBackBtnClick();
            } else {
              this.$message(MsgUtil.getResultMsgData(action, target, false));
            }
          }).catch((e) => {
            this.$message(MsgUtil.getResultMsgData(action, target, false));
            throw new Error(e);
          });
        })
        .catch((e) => {
          this.$message(MsgUtil.getResultMsgData(action, target, false));
          throw new Error(e);
        });
    },
    setUpdateData(data) {
      this.formData = data;
    },
    onBackBtnClick() {
      this.$emit('change-current-view-type', 'mainView');
    },
    onDbtypeComboChange(value) {
      const changeItem = find(this.dbTypeInfo, {
        dbType: value,
      });
      this.formData.dbType = changeItem.dbType;
      this.formData.dbDriver = changeItem.dbDriver;
      this.formData.dbUrl = changeItem.dbUrl;
    },
    getFormData() {
      return {
        name: 'DB 명',
        data: {
          dbId: this.formData.dbId,
        },
      };
    },
  },
};
</script>
<style lang="scss">
.db-setting-popup {
  height: 100%;
  .el-select {
    width: calc(100% + 18px);
    /* margin-left: 10px; */
  }
  .dbtype-item {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/form/DbInfoSettingForm.vue